var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileanalysisFlatline2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 323 255",
    style: {
      enableBackground: "new 0 0 323 255"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FAF1E4;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#231F20;}\r\n\t.st3{fill:#EBCA94;}\r\n\t.st4{fill:#D1D3D4;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_95_profile_analysis"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138,241c-18.9,1-37.6,7.7-56.5,6.4c-35.3-2.5-64.2-33.4-72.2-68c-4.2-18-3.3-37.8,7.1-53 c3.8-5.6,8.8-10.4,12.7-15.8c12.5-17.6,13.3-41.4,25-59.7c13.8-21.3,39.5-30.9,64-37.2c14.4-3.7,28.8-6.8,43.5-9.2 c21.9-3.6,46.3-5.1,64.3,7.8c13.6,9.6,20.8,25.5,30.2,39.2c12.4,18.2,29.1,33.1,42.2,50.8c14.9,20,19.3,39,17,59.5l-0.2,1.8 c-1.4,9.3-3.7,18.5-7.1,27.4c-9.9,27.8-32.2,52.4-61.9,58.8C210.6,257.6,174.4,239.1,138,241z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 163.3,
    cy: 88.7,
    rx: 24.1,
    ry: 27.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M163.3,117.2c-13.6,0-24.6-12.8-24.6-28.4v-1.6c0-8.7,0-16.3,4.9-21.2c3.8-3.8,10.2-5.6,19.7-5.6 s16,1.8,19.7,5.6c5,5,5,12.5,4.9,21.2v1.6C187.9,104.5,176.9,117.2,163.3,117.2z M163.3,61.4c-9.2,0-15.4,1.7-18.9,5.3 c-4.7,4.7-4.6,12-4.6,20.5v1.6c0,15.1,10.6,27.5,23.6,27.5S187,104,187,88.8v-1.6c0-8.5,0-15.9-4.6-20.5 C178.7,63.1,172.5,61.4,163.3,61.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M220.2,205.3c0-17.5-7.3-48.3-13.1-55.7c-7.7-9.8-28.6-20.1-63.4-15c0,0-18,5.6-28.9,17.4 c-8.3,9.1-12.7,46.9-14.2,53.2h119.6V205.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.6,102.3c-1.2-7.3-13.4-9.2-12.8-0.5c0.1,3,1.3,5.8,3.3,8.1c2.1,2.2,5.5,3.2,8.2,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M143.8,112.9c-2.3,0-4.5-1-6-2.6c-2.1-2.4-3.3-5.4-3.4-8.4c-0.3-4.3,2.3-6,4.8-6.3c3.8-0.4,8.3,2.2,9,6.6 c0.1,0.3-0.1,0.6-0.4,0.6l0,0c-0.3,0-0.6-0.2-0.6-0.4c-0.6-3.9-4.7-6.1-7.9-5.8c-1.3,0.1-4.2,0.9-3.9,5.2c0.1,2.9,1.2,5.6,3.1,7.8 c2,2.1,5,2.8,7.6,1.8c0.3-0.1,0.6,0,0.7,0.3c0.1,0.3,0,0.6-0.3,0.7C145.6,112.7,144.6,112.9,143.8,112.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178,102.3c1.2-7.3,13.4-9.2,12.8-0.5c-0.1,3-1.3,5.8-3.3,8.1c-2.1,2.3-5.4,3-8.2,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M181.9,112.9c-1,0-1.9-0.2-2.8-0.6c-0.3-0.1-0.4-0.4-0.3-0.7c0.1-0.3,0.4-0.4,0.7-0.3h0.1 c2.7,1,5.6,0.3,7.6-1.8c1.9-2.2,3-5,3.1-7.8c0.3-4.3-2.6-5.1-3.9-5.2c-3.3-0.4-7.2,1.9-7.9,5.8c0,0.3-0.3,0.5-0.6,0.4 s-0.5-0.3-0.4-0.6c0.7-4.6,5.3-7.1,9-6.6c2.5,0.3,5.1,2.1,4.8,6.3c-0.1,3.2-1.3,6.1-3.4,8.4C186.4,111.9,184.2,112.8,181.9,112.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "177,139.1 150.5,139.1 163,202  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M163,202.5L163,202.5c-0.2,0-0.4-0.2-0.5-0.4L150,139.2c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.2,0.4-0.2H177 c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.1,0.3,0.1,0.4l-14,62.9C163.4,202.4,163.2,202.5,163,202.5z M151.1,139.6l11.9,60.1l13.4-60.1 H151.1L151.1,139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.6,186.1l3.4,16l3.6-16c-0.9-12.1-1.8-33.6-1.8-33.6l1.6-3.5l-3-3l-3,3l2.2,3.8L159.6,186.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M163,202.6L163,202.6c-0.2,0-0.5-0.2-0.5-0.4l-3.4-16c0-0.1,0-0.1,0-0.2l3-33.2l-2.1-3.6 c-0.1-0.2-0.1-0.5,0.1-0.6l3-3c0.1-0.1,0.2-0.2,0.4-0.2l0,0c0.1,0,0.3,0.1,0.4,0.2l3,3c0.2,0.2,0.2,0.4,0.1,0.6l-1.5,3.3 c0.1,1.8,0.9,22,1.8,33.5c0,0.1,0,0.1,0,0.2l-3.6,16C163.5,202.4,163.3,202.6,163,202.6L163,202.6z M160.1,186.1l2.9,13.5l3-13.6 c-0.9-11.9-1.8-33.3-1.8-33.6c0-0.1,0-0.2,0-0.2l1.4-3.1l-2.4-2.4l-2.4,2.4l2,3.4c0.1,0.1,0.1,0.2,0.1,0.3L160.1,186.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177,139.1c0,0-3.3,7.2-13,7.2c-5.5,0.2-10.6-2.6-13.6-7.2l0.4-5.2l1-12l0.9-11.2h22l0.7,9.1l0.2,3L177,139.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164,146.8c-5.6,0.1-11-2.7-14-7.4c-0.1-0.1-0.1-0.2-0.1-0.3l2.3-28.2c0-0.3,0.3-0.5,0.5-0.5h22 c0.3,0,0.5,0.2,0.5,0.5l2.3,28.2c0,0.1,0,0.2,0,0.3C177.5,139.4,173.9,146.8,164,146.8z M151,139c2.9,4.4,7.8,6.9,13,6.8 c8.5,0,11.9-5.8,12.4-6.7l-2.2-27.7h-21L151,139z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.2,119.1c-0.2,1.4-0.8,2.7-1.5,3.8c-1.9,2.7-4.4,4.9-7.2,6.3c-4.8,2.6-11.8,5.6-17.5,4.7l1-12 c4.2,0.5,8.4,0.6,12.7,0.1c3.7-0.3,7.5-0.7,10.9-2.1C176.1,119.7,176.7,119.4,177.2,119.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M153.1,134.6c-0.8,0-1.5-0.1-2.3-0.2c-0.3,0-0.5-0.3-0.4-0.5l1-12c0-0.1,0.1-0.3,0.2-0.4 c0.1-0.1,0.3-0.1,0.4-0.1c4.2,0.5,8.4,0.6,12.6,0.1c3.5-0.3,7.4-0.6,10.8-2.1c0.6-0.3,1.2-0.6,1.7-0.8c0.2-0.1,0.4-0.1,0.5,0 c0.2,0.1,0.2,0.3,0.2,0.5c-0.3,1.4-0.8,2.8-1.6,4.1c-1.9,2.8-4.5,5-7.4,6.5C165.2,131.7,158.9,134.6,153.1,134.6z M151.4,133.5 c5.9,0.7,13.1-2.6,16.7-4.7c2.9-1.4,5.3-3.6,7-6.1c0.5-0.8,0.9-1.7,1.2-2.6l-0.8,0.4c-3.6,1.5-7.5,1.9-11.1,2.2 c-4.1,0.5-8.2,0.5-12.3,0L151.4,133.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.4,124.8h-2c-9.3,0-16.8-7.5-16.8-16.8V81.3h35.7V108C181.2,117.3,173.7,124.8,164.4,124.8L164.4,124.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164.4,125.3h-2c-9.6,0-17.3-7.8-17.3-17.3V81.3c0-0.3,0.2-0.5,0.5-0.5l0,0h35.8c0.3,0,0.5,0.2,0.5,0.5l0,0 V108C181.7,117.5,174,125.3,164.4,125.3z M146,81.8V108c0,9,7.3,16.4,16.4,16.4h2c9,0,16.4-7.3,16.4-16.4V81.8H146z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M166,108c-0.9,0-1.7,0-2.6-0.1c-0.3,0-0.5-0.3-0.5-0.6s0.3-0.5,0.6-0.5c1.6,0.2,3.2,0.2,4.8,0 c0,0,0.1,0,0.1-0.1c0.7-1.2-1.2-7.6-2.8-11.8c-0.1-0.3,0-0.6,0.3-0.7s0.6,0,0.7,0.3c0.7,1.8,4,10.6,2.7,12.7 c-0.2,0.3-0.5,0.5-0.9,0.6C167.6,108,166.7,108,166,108z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165.2,117.7c-2.6,0-5.3-0.3-7.7-0.9c-0.3-0.1-0.5-0.4-0.4-0.6l0,0c0.1-0.3,0.3-0.4,0.6-0.4 c0.1,0,7.7,1.9,14,0c0.3-0.1,0.6,0.1,0.7,0.4c0.1,0.3-0.1,0.6-0.4,0.7C169.6,117.4,167.3,117.7,165.2,117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M274.4,205.8h-228c-0.3,0-0.5-0.2-0.5-0.5V55.5c0-0.3,0.2-0.5,0.5-0.5h228c0.3,0,0.5,0.2,0.5,0.5v149.8 C274.9,205.6,274.6,205.8,274.4,205.8z M46.9,204.8h226.9V56H46.9V204.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M274.4,229.4h-228c-0.3,0-0.5-0.2-0.5-0.5v-23.6c0-0.3,0.2-0.5,0.5-0.5h228c0.3,0,0.5,0.2,0.5,0.5v23.6 C274.9,229.1,274.6,229.4,274.4,229.4z M46.9,228.4h226.9v-22.6H46.9V228.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 195.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -120.2537 108.0686)",
    className: "st2",
    width: 62.7,
    height: 7.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.8,224.5c-0.1,0-0.3-0.1-0.4-0.2l-5.3-5.3c-0.2-0.2-0.2-0.5,0-0.7l0,0l44.4-44.4c0.2-0.2,0.5-0.2,0.7,0l0,0 l5.3,5.3c0.2,0.2,0.2,0.5,0,0.7l-44.4,44.4C51.1,224.5,51,224.5,50.8,224.5z M46.2,218.8l4.6,4.6l43.7-43.7l-4.6-4.6L46.2,218.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.2,194.6l1.9,1.9c2.2,2.2,2.2,5.8,0,8l-28.3,28.3c-2.2,2.2-5.8,2.2-8,0l-1.9-1.9c-2.2-2.2-2.2-5.8,0-8 l28.3-28.3C67.3,192.3,71,192.3,73.2,194.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 109.1,
    cy: 160.6,
    rx: 38.6,
    ry: 38.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.1,199.6c-21.6,0-39-17.4-39-39s17.4-39,39-39s39,17.4,39,39c0,10.4-4.2,20.3-11.4,27.7l-0.4-0.4l0.4,0.4 C129.4,195.6,119.5,199.6,109.1,199.6z M109.1,122.5c-21,0-38.1,17-38.1,38.1s17,38.1,38.1,38.1c10.1,0,19.8-4,27-11.2l0,0 c14.9-14.9,14.9-39,0-53.8C128.8,126.5,119.2,122.5,109.1,122.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 109.1,
    cy: 160.6,
    r: 32.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.1,193.2c-18,0-32.6-14.6-32.6-32.6S91,128,109.1,128s32.6,14.6,32.6,32.6c0,8.6-3.5,16.9-9.5,23.1l0,0 C126,189.7,117.7,193.2,109.1,193.2z M109.1,129c-17.4,0-31.6,14.2-31.6,31.6s14.2,31.6,31.6,31.6c8.4,0,16.5-3.4,22.4-9.3l0,0 c12.3-12.4,12.3-32.4-0.1-44.7C125.4,132.4,117.4,129,109.1,129L109.1,129z M131.9,183.3L131.9,183.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "236.6,117.3 236.6,126.1 218.8,126.1 236.6,136.9 236.6,181.3 314.7,181.3 314.7,117.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M314.7,181.8h-78.2c-0.3,0-0.5-0.2-0.5-0.5v-44l-17.5-10.7c-0.2-0.1-0.3-0.4-0.2-0.6c0.1-0.2,0.3-0.4,0.5-0.4 h17.3v-8.3c0-0.3,0.2-0.5,0.5-0.5h78.2c0.3,0,0.5,0.2,0.5,0.5v64C315.2,181.6,315,181.8,314.7,181.8z M237.1,180.8h77.2v-62.9 h-77.2v8.3c0,0.3-0.2,0.5-0.5,0.5h-16.1l16.3,9.9c0.2,0.1,0.3,0.3,0.3,0.4L237.1,180.8L237.1,180.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "244.6,25.5 244.6,68.1 228.1,76 244.6,76 244.6,88.3 319.3,88.3 319.3,25.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M319.3,88.8h-74.8c-0.3,0-0.5-0.2-0.5-0.5V76.4h-15.9c-0.3,0-0.5-0.2-0.5-0.5c0-0.2,0.1-0.4,0.3-0.5l16.1-7.7 V25.5c0-0.3,0.2-0.5,0.5-0.5h74.7c0.3,0,0.5,0.2,0.5,0.5v62.8C319.8,88.6,319.6,88.8,319.3,88.8z M245,87.8h73.7V26H245v42.1 c0,0.2-0.1,0.4-0.3,0.5l-14.4,6.8h14.2c0.3,0,0.5,0.2,0.5,0.5L245,87.8L245,87.8z M244.5,68.1L244.5,68.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.5,21.5H75.3v26.4h40.8l8.9,11.3V47.9h6.3L131.5,21.5L131.5,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125,59.7c-0.2,0-0.3-0.1-0.4-0.2l-8.8-11.2H75.2c-0.3,0-0.5-0.2-0.5-0.5V21.5c0-0.3,0.2-0.5,0.5-0.5h56.2 c0.3,0,0.5,0.2,0.5,0.5v26.4c0,0.3-0.2,0.5-0.5,0.5h-5.8v10.8c0,0.2-0.1,0.4-0.3,0.5C125.2,59.7,125.1,59.7,125,59.7z M75.8,47.3 h40.3c0.2,0,0.3,0.1,0.4,0.2l8,10.2v-9.9c0-0.3,0.2-0.5,0.5-0.5h5.8V22H75.7L75.8,47.3L75.8,47.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "90.1,82.3 75.4,82.3 75.4,71.4 2.7,71.4 2.7,118.1 75.4,118.1 75.4,89.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.4,118.6H2.7c-0.3,0-0.5-0.2-0.5-0.5V71.4c0-0.3,0.2-0.5,0.5-0.5h72.6c0.3,0,0.5,0.2,0.5,0.5v10.4h14.3 c0.2,0,0.4,0.2,0.5,0.4c0.1,0.2-0.1,0.5-0.3,0.6l-14.5,6.8V118C75.9,118.4,75.7,118.6,75.4,118.6z M3.2,117.6h71.7V89.3 c0-0.2,0.1-0.4,0.3-0.5l12.7-5.9H75.4c-0.3,0-0.5-0.2-0.5-0.5V71.9H3.2V117.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M122.9,218.8v4.6h-4.8v-14.1h6c0.7,0,1.4,0.1,2.1,0.2c0.7,0.1,1.3,0.4,1.9,0.8c0.6,0.4,1,0.9,1.3,1.5 c0.4,0.7,0.5,1.5,0.5,2.3s-0.1,1.6-0.5,2.3c-0.3,0.6-0.8,1.1-1.3,1.5c-0.6,0.4-1.2,0.7-1.9,0.8c-0.7,0.2-1.4,0.3-2.2,0.3 L122.9,218.8z M122.9,212.9v2.3h1c0.4,0,0.7-0.1,1-0.3s0.5-0.6,0.5-0.9c0-0.2,0-0.4-0.1-0.5s-0.2-0.3-0.3-0.3 c-0.1-0.1-0.3-0.1-0.5-0.2c-0.2,0-0.4,0-0.5-0.1H122.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M131.9,209.2h6c0.7,0,1.4,0.1,2.1,0.2c0.7,0.1,1.3,0.4,1.9,0.8c0.5,0.4,1,0.8,1.3,1.4c0.4,0.7,0.5,1.5,0.5,2.3 s-0.2,1.6-0.6,2.3c-0.5,0.7-1.1,1.2-1.8,1.5l3.6,5.7h-5.5l-2.7-5.1h-0.1v5.1H132L131.9,209.2z M136.4,215.1h0.9c0.2,0,0.4,0,0.5,0 c0.2,0,0.4-0.1,0.5-0.2c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.2-0.4,0.2-0.6s0-0.4-0.1-0.6c-0.1-0.1-0.2-0.3-0.4-0.3 c-0.1-0.1-0.3-0.1-0.5-0.1h-0.5h-1.1L136.4,215.1L136.4,215.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M145.4,216.2c0-1,0.2-2.1,0.6-3c0.4-0.9,1-1.7,1.7-2.3c0.7-0.7,1.6-1.2,2.5-1.5c1-0.4,2.1-0.5,3.1-0.5 c1.1,0,2.1,0.2,3.1,0.5c0.9,0.3,1.8,0.8,2.5,1.5s1.3,1.5,1.7,2.3c0.4,1,0.6,2,0.6,3c0,1.1-0.2,2.1-0.6,3.1c-0.4,0.9-1,1.7-1.7,2.4 s-1.6,1.2-2.5,1.5c-1,0.4-2.1,0.6-3.1,0.5c-1.1,0-2.1-0.2-3.1-0.5c-0.9-0.3-1.8-0.9-2.5-1.5c-0.7-0.7-1.3-1.5-1.7-2.4 C145.6,218.3,145.4,217.2,145.4,216.2z M150.5,216.2c0,0.4,0.1,0.9,0.2,1.3c0.1,0.4,0.3,0.7,0.6,1c0.2,0.3,0.5,0.5,0.9,0.7 s0.7,0.2,1.1,0.2c0.4,0,0.8-0.1,1.1-0.2c0.3-0.2,0.6-0.4,0.9-0.7c0.3-0.3,0.5-0.6,0.6-1s0.2-0.9,0.2-1.3s-0.1-0.8-0.2-1.2 c-0.1-0.4-0.3-0.7-0.6-1s-0.6-0.5-0.9-0.6c-0.4-0.2-0.7-0.2-1.1-0.2c-0.4,0-0.8,0.1-1.1,0.2s-0.6,0.3-0.9,0.6 c-0.3,0.3-0.5,0.6-0.6,1C150.6,215.3,150.5,215.7,150.5,216.2L150.5,216.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M167.8,214.6h4.4v3.9h-4.3v4.8h-4.7v-14h9.5v4h-4.9V214.6L167.8,214.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M174.8,209.2h4.8v14.1h-4.8V209.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M182.2,209.2h4.8v10h4.7v4.1h-9.5V209.2L182.2,209.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M193.1,209.2h9.7v4h-5.3v1.2h5v3.7h-5v1.3h5.6v4h-10V209.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M274.4,169.2c-11.6,0-21-9.4-21-21s9.4-21,21-21s21,9.4,21,21C295.4,159.7,286,169.2,274.4,169.2L274.4,169.2z  M274.4,128.2c-11.1,0-20,9-20,20c0,11.1,9,20,20,20s20-9,20-20v-0.1C294.4,137.1,285.4,128.1,274.4,128.2L274.4,128.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M280.3,168.3c-0.2,0-0.4-0.1-0.5-0.4l-5.9-19.6c0-0.1,0-0.3,0.1-0.4l11.9-16.7c0.2-0.2,0.5-0.3,0.7-0.1l0,0 c0.2,0.2,0.3,0.5,0.1,0.7l-11.8,16.6l5.8,19.4C280.8,168,280.6,168.2,280.3,168.3L280.3,168.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M274.4,148.6c-0.1,0-0.2,0-0.2-0.1l-18.1-9.6c-0.2-0.1-0.3-0.4-0.2-0.7c0.1-0.2,0.4-0.3,0.7-0.2l0,0l18.1,9.6 c0.2,0.1,0.3,0.4,0.2,0.7l0,0C274.7,148.5,274.5,148.6,274.4,148.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27.1,111.5h-7.4c-0.3,0-0.5-0.2-0.5-0.5V77c0-0.3,0.2-0.5,0.5-0.5h7.4c0.3,0,0.5,0.2,0.5,0.5v34 C27.6,111.3,27.4,111.5,27.1,111.5z M20.2,110.5h6.4v-33h-6.4C20.2,77.5,20.2,110.5,20.2,110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.3,111.5h-7.4c-0.3,0-0.5-0.2-0.5-0.5V87.4c0-0.3,0.2-0.5,0.5-0.5h7.4c0.3,0,0.5,0.2,0.5,0.5V111 C43.8,111.3,43.6,111.5,43.3,111.5z M36.4,110.5h6.4V88h-6.3L36.4,110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M59.5,111.5h-7.4c-0.3,0-0.5-0.2-0.5-0.5V96c0-0.3,0.2-0.5,0.5-0.5h7.4c0.3,0,0.5,0.2,0.5,0.5v15 C60,111.3,59.8,111.5,59.5,111.5z M52.7,110.5h6.4V96.4h-6.4V110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.7,111.5H12.4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h53.2c0.3,0,0.5,0.2,0.5,0.5 C66.1,111.3,66,111.5,65.7,111.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M309,139.6h-8.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h8.3c0.3,0,0.5,0.2,0.5,0.5 C309.5,139.4,309.3,139.6,309,139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M309,144h-8.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h8.3c0.3,0,0.5,0.2,0.5,0.5S309.3,144,309,144z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M304.7,148.6h-4.1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h4.1c0.3,0,0.5,0.2,0.5,0.5 C305.2,148.4,305,148.6,304.7,148.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M253.2,161.6h-9.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h9.6c0.3,0,0.5,0.2,0.5,0.5 C253.7,161.3,253.4,161.6,253.2,161.6L253.2,161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M249.8,165.4h-6.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6.2c0.3,0,0.5,0.2,0.5,0.5 C250.2,165.2,250,165.4,249.8,165.4L249.8,165.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M256.9,67.4c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7l16.7-12.9c0.2-0.2,0.5-0.1,0.7,0.1l9.6,10.9 l23.7-20.9c0.2-0.2,0.5-0.2,0.7,0l0,0c0.2,0.2,0.2,0.5,0,0.7l0,0l-24.2,21.3c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3-0.1-0.3-0.2 l-9.5-11l-16.4,12.6C257.2,67.3,257.1,67.4,256.9,67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M310.9,71.7h-57.1c-0.3,0-0.5-0.2-0.5-0.5V38.3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v32.4h56.6 c0.3,0,0.5,0.2,0.5,0.5S311.2,71.7,310.9,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M279.8,38.8H259c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h20.8c0.3,0,0.5,0.2,0.5,0.5S280.1,38.8,279.8,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M279.8,42.6H259c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h20.8c0.3,0,0.5,0.2,0.5,0.5S280.1,42.6,279.8,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M268.7,46.4H259c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h9.7c0.3,0,0.5,0.2,0.5,0.5 C269.2,46.2,269,46.4,268.7,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M91,45.3c-0.3,0-0.5-0.2-0.5-0.5V25.1c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v19.7 C91.5,45.1,91.2,45.3,91,45.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M123.6,29.1H80.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h42.8c0.3,0,0.5,0.2,0.5,0.5 C124.1,28.9,123.9,29.1,123.6,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M123.6,35.4H80.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h42.8c0.3,0,0.5,0.2,0.5,0.5S123.9,35.4,123.6,35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M123.6,41.8H80.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h42.8c0.3,0,0.5,0.2,0.5,0.5 C124.1,41.6,123.9,41.8,123.6,41.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 97.1,
    cy: 159.7,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 109.5,
    cy: 159.7,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 121.9,
    cy: 159.7,
    r: 3.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileanalysisFlatline2);
export default __webpack_public_path__ + "static/media/Profile analysis _Flatline-2.277cf09a0e0362df179c5d057d56665e.svg";
export { ForwardRef as ReactComponent };